import React from 'react';
import { loadGoogleOneTap } from '../../actions/google';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    INotificationContext,
    useNotificationsContext,
} from '../../contexts/NotificationsContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';

const SocialOneTap = () => {
    const configContext: IConfigContextProps = useConfigContext();
    const notificationsContext: INotificationContext = useNotificationsContext();
    const userContext: IUserContext = useUserContext();

    React.useEffect(() => {
        if (configContext?.featureFlags?.launchGoogleOneTapWeb) {
            loadGoogleOneTap({
                notificationsContext,
                configContext,
                userContext,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default SocialOneTap;
